import { render, staticRenderFns } from "./IntroducingPage.vue?vue&type=template&id=b576d8b2&scoped=true&"
import script from "./IntroducingPage.vue?vue&type=script&lang=js&"
export * from "./IntroducingPage.vue?vue&type=script&lang=js&"
import style0 from "./IntroducingPage.vue?vue&type=style&index=0&id=b576d8b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b576d8b2",
  null
  
)

export default component.exports